import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";
import { COMPANY } from "@/data/company";
import { ZONES } from "@/data/locales";

const servicesCol = [
  { label: "Enseigne lumineuse", to: "/enseigne-lumineuse/" },
  { label: "Lettres boîtiers", to: "/lettres-boitiers/" },
  { label: "Lettres relief", to: "/lettres-relief/" },
  { label: "Caisson lumineux", to: "/caisson-lumineux/" },
  { label: "Signalétique", to: "/signaletique/" },
  { label: "Communication visuelle", to: "/communication-visuelle/" },
];

export default function Footer() {
  return (
    <footer className="relative border-t border-white/10 bg-ink-900 noise-overlay" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <img src={COMPANY.logo} alt="Logo Ronalp Enseigne" className="h-11 w-auto" width="170" height="44" />
            <p className="mt-5 text-sm font-mono uppercase tracking-wider text-signature">{COMPANY.tagline}</p>
            <p className="mt-4 text-sm text-slate-400 leading-relaxed">
              Fabricant et installateur d'enseignes lumineuses et de communication visuelle, de la conception à la pose, en France et en Suisse.
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-white mb-5">Services</h3>
            <ul className="space-y-2.5">
              {servicesCol.map((s) => (
                <li key={s.to}>
                  <Link to={s.to} className="text-sm text-slate-400 hover:text-signature transition-colors">{s.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-white mb-5">Zones d'intervention</h3>
            <ul className="space-y-2.5">
              {ZONES.map((z) => (
                <li key={z.key}>
                  <Link to={`/${z.hub}/`} className="text-sm text-slate-400 hover:text-signature transition-colors flex items-center gap-1.5">
                    {z.label} <span className="text-[10px] font-mono text-chrome-dark">{z.country === "Suisse" ? "CH" : "FR"}</span>
                  </Link>
                </li>
              ))}
              <li><Link to="/zones-intervention/" className="text-sm text-white hover:text-signature flex items-center gap-1">Toutes les zones <ArrowUpRight className="h-3.5 w-3.5" /></Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-white mb-5">Contact</h3>
            <ul className="space-y-4 text-sm text-slate-400">
              <li>
                <a href={COMPANY.phoneHref} className="flex items-start gap-3 hover:text-white transition-colors">
                  <Phone className="h-4 w-4 mt-0.5 text-signature shrink-0" /> {COMPANY.phone}
                </a>
              </li>
              <li>
                <a href={COMPANY.emailHref} className="flex items-start gap-3 hover:text-white transition-colors">
                  <Mail className="h-4 w-4 mt-0.5 text-signature shrink-0" /> {COMPANY.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-4 w-4 mt-0.5 text-signature shrink-0" />
                <span>{COMPANY.address.street}<br />{COMPANY.address.postalCode} {COMPANY.address.city}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 border-t border-white/10 pt-8 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-chrome-dark">© {new Date().getFullYear()} {COMPANY.name} — marque de {COMPANY.legal.company} ({COMPANY.legal.form}). Tous droits réservés.</p>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-slate-500">
            <Link to="/realisations/" className="hover:text-white">Réalisations</Link>
            <Link to="/conseils/" className="hover:text-white">Conseils</Link>
            <Link to="/contact/" className="hover:text-white">Contact</Link>
            <Link to="/mentions-legales/" className="hover:text-white">Mentions légales</Link>
            <Link to="/politique-confidentialite/" className="hover:text-white">Confidentialité</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
